import styled from "styled-components";
import { media } from "../../../../../components/common/media";

const TrendingContainer = styled.section`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto 30px;
  padding: 0 15px;
  h2 {
    color: #000;
    font-weight: 700 !important;
    font-size: 24px !important;
    padding-left: 0 !important;
    a {
      float: right;
      text-transform: uppercase;
      color: ${(props) => props.theme.colors.primary.main};
      transition: all 0.6s ease 0s;
      font-weight: 400;
      letter-spacing: 1px;
      font-size: 14px;
      cursor: pointer;
      position: relative;
      top: 10px;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .tab-content {
    padding-top: 10px;

    > .active {
      display: block;
    }

    .trendingItem {
      .carousel {
        padding-bottom: 35px;
        .control-dots {
          .dot {
            outline: 0;
            box-shadow: none;
            background: #d8d8d8;
            &.selected {
              background: ${(props) => props.theme.colors.primary.main}
            }
          }
        }
      }
      .slide {
        background: transparent;
      }

      .flex {
        width: 100%;
        max-width: 1230px;
        margin: auto;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
      }
      .result-item {
        max-width: 260px;
        min-width: 260px;
        margin: 5px;
        ${media.desktop`
          margin: auto;
        `}

        img {
          margin: auto;
          height: 100%;
          display: block;
          max-width: 260px;
          background: #000;
          border: 0;
          max-height: 148px;
        }

        .img-responsive {
          display: block;
          max-width: 100%;
          height: auto;
        }
      }

      .image-container {
        width: 100%;
        max-width: 260px;
        background: #000;
        height: 148px;
        cursor: pointer;
        position: relative;

        .video-thumbnail-container {
          height: 100%;
        }

        &:hover {
          .itemBottom {
            display: block;
          }
        }
      }

      .itemBottom {
        border-right: 0;
        border-left: 0;
        display: none;
        position: relative;
        z-index: 1000;
        top: 122px;
        background: rgba(0, 0, 0, 0.75);
        overflow: hidden;
        width: 100%;

        ${media.desktop`
          display: none !important;
        `};
      }

      h3 {
        font-size: 14px;
      }
    }
  }
  .itemTitle {
    background: #fff;
    ${media.desktop`
      text-align: left;
    `}
    &:hover {
      h3,
      p {
        color: ${(props) => props.theme.colors.primary.main}
      }
    }
  }
  .imgthumb img {
    border: 0;
    overflow: hidden !important;
  }
`;

export default TrendingContainer;
